import type { AssetId } from '../assets/AssetTypes';
import type { ColliderBox } from '../obstacles/ObstacleDefinition';
import type { CollectibleType } from './CollectibleType';

export const CollectibleEffect = {
  /** Adds the configured bottle value to the bottle counter. */
  AddBottles: 'ADD_BOTTLES',
  AddExtraLife: 'ADD_EXTRA_LIFE',
  /**
   * Turbo (beer crate, user 2026-10-03): for a few seconds invulnerable, blinking and faster (TurboBoost); the crate's
   * bottle value counts as well. Placed only where it is hard to reach (container roofs, high lines).
   */
  Turbo: 'TURBO',
  /** Pulls bottles in for a while (CollectibleMagnet). Not placed by the level generator yet. */
  Magnet: 'MAGNET',
  /** Prepared – not implemented yet. */
  TimeBonus: 'TIME_BONUS',
} as const;
export type CollectibleEffect = (typeof CollectibleEffect)[keyof typeof CollectibleEffect];

export interface CollectibleDefinition {
  readonly id: string;
  readonly type: CollectibleType;
  readonly displayName: string;
  readonly visualAssetId: AssetId;
  readonly effect: CollectibleEffect;
  /** Pickup volume (generous on purpose – collecting should feel easy). */
  readonly collider: ColliderBox;
  readonly spins: boolean;
  /**
   * Can a magnet pull it in? Default: bottle pickups only (effect ADD_BOTTLES). The golden bottle says
   * false – it hangs where only a double jump from the ramp gets (SEG_GOLDEN_RAMP_60M).
   */
  readonly magnetic?: boolean;
}
